export const SET_MODAL = "SET_MODAL";
